import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth'
import MainLayout from '@/components/Layout'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import TestCases from '@/pages/TestCases'
import Timers from '@/pages/Timers'
import TimerRuns from '@/pages/TimerRuns'
import ApiTest from '@/pages/ApiTest'
import Scenarios from '@/pages/ApiTest/Scenarios'
import Mock from '@/pages/ApiTest/Mock'
import UIAutomation from '@/pages/UIAutomation'
import UIElements from '@/pages/UIAutomation/UIElements'
import UIExecutions from '@/pages/UIAutomation/UIExecutions'
import UIHealing from '@/pages/UIAutomation/UIHealing'
import UIReviews from '@/pages/UIAutomation/UIReviews'
import UIDashboard from '@/pages/UIAutomation/UIDashboard'
import Reports from '@/pages/Reports'
import SharedReport from '@/pages/Reports/SharedReport'
import Capture from '@/pages/Tools/Capture'
import DataFactory from '@/pages/Tools/DataFactory'
import PayloadDebug from '@/pages/Tools/PayloadDebug'
import LogText from '@/pages/Tools/LogText'
import KnowledgeBase from '@/pages/KnowledgeBase'
import Projects from '@/pages/Projects'
import Environments from '@/pages/Environments'
import AITestCases from '@/pages/AITestCases'
import ThemeSettings from '@/pages/Settings/Theme'
import LLMConfig from '@/pages/Settings/LLMConfig'
import UserManagement from '@/pages/Settings/UserManagement'
import Services from '@/pages/Settings/Services'
import Drivers from '@/pages/Settings/Drivers'
import UIModuleSettings from '@/pages/Settings/UIModuleSettings'
import Profile from '@/pages/Profile'

function App() {
  const token = useAuthStore((s) => s.token)

  return (
    <Routes>
      {/* 登录页 */}
      <Route path="/login" element={<Login />} />

      {/* 分享报告只读页（四期 K：token 鉴权，无需登录） */}
      <Route path="/reports/share" element={<SharedReport />} />

      {/* 受保护路由 */}
      <Route path="/" element={token ? <MainLayout /> : <Navigate to="/login" replace />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="environments" element={<Environments />} />
        <Route path="test-cases" element={<TestCases />} />
        <Route path="timers" element={<Timers />} />
        <Route path="timer-runs" element={<TimerRuns />} />
        <Route path="api-test" element={<ApiTest />} />
        <Route path="api-test/scenarios" element={<Scenarios />} />
        <Route path="api-test/mock" element={<Mock />} />
        <Route path="ui-automation" element={<UIAutomation />} />
        <Route path="ui-automation/elements" element={<UIElements />} />
        <Route path="ui-automation/executions" element={<UIExecutions />} />
        <Route path="ui-automation/healing" element={<UIHealing />} />
        <Route path="ui-automation/reviews" element={<UIReviews />} />
        <Route path="ui-automation/dashboard" element={<UIDashboard />} />
        <Route path="reports" element={<Reports />} />
        <Route path="tools/capture" element={<Capture />} />
        <Route path="tools/data-factory" element={<DataFactory />} />
        <Route path="tools/payload-debug" element={<PayloadDebug />} />
        <Route path="tools/log-text" element={<LogText />} />
        <Route path="knowledge-base" element={<KnowledgeBase />} />
        <Route path="ai-test-cases" element={<AITestCases />} />
        <Route path="settings/theme" element={<ThemeSettings />} />
        <Route path="settings/llm" element={<LLMConfig />} />
        <Route path="settings/services" element={<Services />} />
        <Route path="settings/drivers" element={<Drivers />} />
        <Route path="settings/ui-module" element={<UIModuleSettings />} />
        <Route path="settings/users" element={<UserManagement />} />
        <Route path="profile" element={<Profile />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
